<template>
  <v-row dense>
    <v-col cols="4">
      <v-autocomplete
        v-model="selectedComplexId"
        :items="complexes"
        item-value="id"
        item-text="text"
        label="مجموعه"
        :search-input.sync="searchComplex"
        outlined
        dense
        hide-details
        hide-selected
        no-data-text="موردی یافت نشد"
        @change="getSubComplexes"
      ></v-autocomplete>
    </v-col>
    <v-col cols="4">
      <v-autocomplete
        v-model="selectedSubComplexId"
        :items="subComplexes"
        item-value="id"
        item-text="text"
        label="زیر مجموعه"
        :search-input.sync="searchSubComplex"
        outlined
        dense
        hide-details
        hide-selected
        no-data-text="موردی یافت نشد"
        @change="getDevices(selectedSubComplexId)"
      ></v-autocomplete>
    </v-col>
    <v-col cols="4">
      <v-autocomplete
        v-model="deviceId"
        :items="devices"
        item-value="id"
        item-text="text"
        label="دستگاه"
        :search-input.sync="searchDevice"
        outlined
        dense
        hide-details
        hide-selected
        no-data-text="موردی یافت نشد"
      ></v-autocomplete>
    </v-col>
  </v-row>
</template>

<script>
import request from "@/utils/request";
import { hasPermission } from "@/composables/permissions";

export default {
  name: "DeviceFilterDropDown",
  data() {
    return {
      selectedComplexId: null,
      selectedSubComplexId: null,
      deviceId: null,
      searchComplex: null,
      searchSubComplex: null,
      searchDevice: null,
      subComplexes: [],
      complexes: [],
      devices: []
    };
  },
  created() {
    this.getComplexes();
  },
  methods: {
    async getComplexes() {
      await request.get(`/publicData/main-complexes`).then(response => {
        var data = response.data.result;
        this.complexes = data;
        this.complexes.unshift({ id: null, text: "انتخاب..." });
      });
    },
    async getSubComplexes() {
      if (this.selectedComplexId) {
        await request
          .get(`/publicData/sub-complexes/${this.selectedComplexId}`)
          .then(response => {
            var data = response.data.result;
            this.subComplexes = data;
            this.subComplexes.unshift({ id: null, text: "انتخاب..." });
            this.getDevices(this.selectedComplexId);
          });
      }
    },
    async getDevices(complexId) {
      if (complexId) {
        await request
          .get(`/publicData/main-complexes-devices/${complexId}`)
          .then(response => {
            var data = response.data.result;
            this.devices = data;
            this.devices.unshift({ id: null, text: "انتخاب..." });
          });
      }
    }
  }
};
</script>

<style scoped>
/* Modal Content (image) */
</style>
